<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="table">
          <table class="table">
            <thead class=" text-primary">
              <tr>
                <th>
                  Name
                </th>
                <th>
                  <router-link v-if="$dataManager.getters.permissions.GameType.includes('create')" :to="{name:'GameType.Create'}">
                    <div class="btn btn-xs btn-success btn-round pull-right">Create</div>
                  </router-link>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in gameType" :key="i">
                <td v-text="item.name" />
                <td>
                  <router-link v-if="$dataManager.getters.permissions.GameType.includes('update')" :to="{name:'GameType.Update',params:{id:item.id}}">
                    <div class="btn btn-xs btn-primary  pull-right">Update</div>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameTypeList',
  data: function() {
    return {
      gameType: []
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData: function() {
      this.$store.commit('OPEN_LOADING')

      this.$store.dispatch('getList', { type: 'GameType', action: 'list' }).then((res) => {
        if (!res.errorCode) {
          this.gameType = res.data
          this.$store.commit('CLOSE_LOADING')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
